module.exports = __webpack_public_path__ + "static/media/logo-cliengo.98beda5c.svg";